import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

// Due to SSR Jodit needs to be imported this way else page will crash with "window is not defined error"
const Jodit = React.lazy(() => {
  return import('jodit-react');
});

const GreetingText = ({
  greetingText,
  setGreetingText,
  formatMessage,
  messages,
  hasError,
}) => {
  const isSSR = typeof window === 'undefined';

  const config = useMemo(() => {
    const buttons = 'underline, align, brush';
    const style = {
      fontSize: '18px',
    };
    if (hasError) {
      style.border = '1px solid red';
      style.backgroundColor = '#ffeeee';
    }
    return {
      buttons,
      buttonsMD: buttons,
      buttonsSM: buttons,
      buttonsXS: buttons,
      showWordsCounter: false,
      showPlaceholder: false,
      colorPickerDefaultTab: 'text',
      defaultActionOnPaste: 'insert_only_text',
      askBeforePasteHTML: false,
      limitChars: 400,
      style,
    };
  }, [hasError]);

  return (
    <div>
      <h3>{formatMessage({ ...messages.typeYourMessageHere })}</h3>
      {!isSSR && (
        <React.Suspense fallback={<div />}>
          <Jodit
            value={greetingText}
            config={config}
            onChange={setGreetingText}
          />
        </React.Suspense>
      )}
    </div>
  );
};

GreetingText.propTypes = {
  greetingText: PropTypes.string,
  setGreetingText: PropTypes.func.isRequired,
  messages: PropTypes.shape().isRequired,
  formatMessage: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
};

GreetingText.defaultProps = {
  greetingText: '',
  hasError: false,
};

export default GreetingText;
